import { Subject } from 'rxjs';
import { chatService } from './service';

export class ChatStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.subject = new Subject();
    this.messages = [];
    this.totalCount = 0;
    this.page = 1;
    this.sending = false;
  }

  _emit() { this.subject.next(this); }

  setMessages(list, total) {
    this.messages = list || [];
    if (total !== undefined) this.totalCount = total;
    this._emit();
  }

  async loadMore() {
    const res = await chatService.list(this.page);
    if (res.messages && res.messages.length) {
      this.messages = this.messages.concat(res.messages);
      this.totalCount = res.total_count || this.totalCount;
      this.page += 1;
      this._emit();
    }
    return res;
  }

  async send(content, file) {
    // Оптимистичная отправка: временное сообщение появляется в списке сразу,
    // после ответа сервера заменяется настоящим; при ошибке помечается failed.
    // Флаг sending эмитится, чтобы UI мог задизейблить кнопку отправки.
    const temp = {
      id: 'tmp-' + Date.now(),
      content: content || '',
      who_wrote: 'messageable',
      image: null,
      pending: true,
    };
    this.sending = true;
    this.messages = [temp].concat(this.messages);
    this._emit();
    try {
      const res = await chatService.send(content, file);
      if (res.message) {
        this.messages = this.messages.map((m) => (m.id === temp.id ? res.message : m));
      } else {
        this.messages = this.messages.filter((m) => m.id !== temp.id);
      }
      return res;
    } catch (e) {
      this.messages = this.messages.map((m) => (
        m.id === temp.id ? Object.assign({}, m, { pending: false, failed: true }) : m
      ));
      throw e;
    } finally {
      this.sending = false;
      this._emit();
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/chatStore/index.js